import { render } from "./WindowTray.vue?vue&type=template&id=d32d5684"
import script from "./WindowTray.vue?vue&type=script&lang=js"
export * from "./WindowTray.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__